type Identifiable = {
    id: ID
}

// Drop the dragged item out of the list wherever it sat, then put it back beside the target.
// Removing first is what keeps the index right whether or not both are already in the same list -
// splicing against the original array is off by one whenever the dragged item sat before the target.
export default function menuProjects_insertNextTo<T extends Identifiable>(siblings: T[], dragged: T, target: T, isHoverTop: boolean): T[] {
    const res = _.reject(siblings, (item: T) => {
        return item.id === dragged.id
    })

    const index = _.findIndex(res, (item: T) => {
        return item.id === target.id
    })

    if (index === -1) {
        return res.concat([dragged])
    }

    res.splice(index + (isHoverTop ? 0 : 1), 0, dragged)

    return res
}
